import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// Initialize i18n before rendering
import './i18n';

import LoginPage from './LoginPage'


import 'bootstrap/dist/css/bootstrap.css';
import "bootswatch/dist/darkly/bootstrap.min.css";
import './index.css';

import * as serviceWorker from './serviceWorker';


import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {GlobalContextProvider} from "./context";
import {PromptModalProvider} from "./PromptModal";

ReactDOM.render(
    <React.StrictMode>
      <PromptModalProvider>
        <ToastContainer/>
        <LoginPage>
          <GlobalContextProvider>
            <App/>
          </GlobalContextProvider>
        </LoginPage>
      </PromptModalProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
